import { h, Component } from 'preact'
import { connect } from 'unistore/preact'

const translateKey = (translations, key, params) => {
    if (!translations)
        return null
    let result = translations[key]
    if (typeof result === 'string' && params && params.length > 0) {
        params.forEach((param, index) => {
        result = result.replace(`{${index}}`, param)
        })
    } else if (typeof result === 'function') {
        result = result.apply(null, params)
    }
    return result
}


const injectTranslationsFunction = (component) => {
    return (props) => component({
        ...props,
        translate: (key, ...params) => translateKey(props.translations, key, params)
    })
}

const injectTranslationsComponent = (component) => {
    const _component = component
    return class extends Component {
        constructor(props) {
        super(props)
        this.translate = this.translate.bind(this)
        }
        translate = (key, ...params) => translateKey(this.props.translations, key, params)
        render(props) {
        return <_component  {...props} translate={this.translate} />
        }
    }
}

const isStatelessFunction = (component) => {
    const result = !component.prototype.render
    return result
}

export const connectWithTranslations = (stateProperties, actions) => {
    return (component) => {
        const customProperties = stateProperties ? `,${stateProperties}` : ''
        const injection = isStatelessFunction(component) ?
        injectTranslationsFunction(component)
        : injectTranslationsComponent(component)
        const result = connect('translations' + customProperties, actions)(injection)
        return result
    }
}
